import { ANNOTATION_DAAS_AUTHORIZED } from '@internal/backstage-plugin-daas-common';

import { Entity } from '@backstage/catalog-model';

import { KubernetesCluster } from './types';

/** Maps a `kubernetes-cluster` resource entity onto the picker's option shape. */
export const serializeClusterEntity = (entity: Entity): KubernetesCluster => ({
  id: `${entity.kind}:${entity.metadata.namespace || 'default'}/${
    entity.metadata.name
  }`,
  name: entity.metadata.name,
  title: entity.metadata.title || entity.metadata.name,
  isDaaSAuthorized:
    entity.metadata.annotations?.[ANNOTATION_DAAS_AUTHORIZED] === 'true',
  subscriptionId: entity.metadata.annotations?.['azure.com/subscription-id'],
  resourceGroup: entity.metadata.annotations?.['azure.com/resource-group'],
});
